import values from 'lodash/values';

const defaultInitialState = {
	columns: {
		date: {
			index: 'date',
			title: 'Date'
		},
		manager: {
			index: 'manager',
			title: 'Manager'
		},
		country: {
			index: 'country',
			title: 'Country',
			className: 'padding-0-15'
		},
		offer: {
			index: 'offer',
			title: 'Offer',
			className: 'long'
		},
		affiliate_id: {
			index: 'affiliate_id',
			title: 'Affiliate id'
		},
		total: {
			index: 'approved',
			title: 'Approved',
			className: 'padding-0-15'
		},
		approved: {
			index: 'total',
			title: 'Total'
		},
		payouts: {
			index: 'payouts',
			title: 'Payouts (by approved conversions/default)',
			className: 'padding-0-15 long'
		},
		comment: {
			index: 'comment',
			title: 'Comment',
			className: 'long'
		}
	}
};

const createTable = ({
	namespace,
	stateNodeName
}) => {

	// initState
	const initialState = {
		...defaultInitialState
	};

	// actions
	const actions = Object.assign({});

	// reducers
	const reducers = Object.assign({});

	// selectors
	const selectors = {
		getTable: state => {
			const { data } = state[namespace];
			const table = state[namespace][stateNodeName];

			return {
				headers: values(table.columns),
				rows: data && data.result,
				cols: data && data.columns
			};
		}
	};

	return {
		initialState,
		selectors,
		actions,
		reducers
	};
};

export default createTable;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/traffic-accounting/components/table-start/index.js